import { action } from 'easy-peasy';
import { IActionRemoveCrisisCallTeamMemberAllocationsByCrisisCall } from '../types';
import { removeAllocations } from './helpers';

const removeCrisisCallTeamMemberAllocationsByCrisisCall: IActionRemoveCrisisCallTeamMemberAllocationsByCrisisCall =
  action((state, { crisisCallId }) => {
    state.crisisCallTeamMembers.forEach(member => {
      removeAllocations(member, allocation => allocation.crisisCallId === crisisCallId);
    });
  });

export default removeCrisisCallTeamMemberAllocationsByCrisisCall;
